(function () {
  function createController(root) {
    if (!root || root.dataset.erSetupReady === 'true') return;
    root.dataset.erSetupReady = 'true';

    var modelChoices = Array.prototype.slice.call(root.querySelectorAll('[data-er-model-choice]'));
    var modelPlaceholder = root.querySelector('[data-er-model-placeholder]');
    var modelCard = root.querySelector('[data-er-model-card]');
    var modelImage = root.querySelector('[data-er-model-image]');
    var modelTitle = root.querySelector('[data-er-model-title]');
    var modelVariant = root.querySelector('[data-er-model-variant]');
    var modelPrice = root.querySelector('[data-er-model-price]');
    var modelDescription = root.querySelector('[data-er-model-description]');
    var modelStock = root.querySelector('[data-er-model-stock]');
    var accessoryPrompt = root.querySelector('[data-er-accessory-prompt]');
    var accessoryEmpty = root.querySelector('[data-er-accessory-empty]');
    var accessoryCards = Array.prototype.slice.call(root.querySelectorAll('[data-er-accessory]'));
    var summaryEmpty = root.querySelector('[data-er-summary-empty]');
    var summaryList = root.querySelector('[data-er-summary-list]');
    var total = root.querySelector('[data-er-total]');
    var addToCart = root.querySelector('[data-er-add-to-cart]');
    var checkout = root.querySelector('[data-er-checkout]');
    var status = root.querySelector('[data-er-status]');
    var progressSteps = Array.prototype.slice.call(root.querySelectorAll('[data-er-progress-step]'));
    var sceneDialog = root.querySelector('[data-er-scene-dialog]');
    var sceneImage = root.querySelector('[data-er-scene-image]');
    var sceneTitle = root.querySelector('[data-er-scene-title]');
    var sceneCaption = root.querySelector('[data-er-scene-caption]');
    var sceneClose = root.querySelector('[data-er-scene-close]');

    if (!modelChoices.length || !addToCart || !checkout || !summaryList) return;

    var currency = root.dataset.currency || 'USD';
    var locale = document.documentElement.lang || 'en-US';
    var isSubmitting = false;
    var sceneReturnFocus = null;
    var formatter;
    try {
      formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (error) {
      formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
    var fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
    var divisor = Math.pow(10, fractionDigits);

    function formatMoney(cents) {
      return formatter.format((Number(cents) || 0) / divisor);
    }

    function currentModelOption() {
      return modelChoices.find(function (choice) {
        return choice.classList.contains('is-selected');
      }) || null;
    }

    function selectModel(choice) {
      modelChoices.forEach(function (candidate) {
        var selected = candidate === choice;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
        candidate.tabIndex = selected ? 0 : -1;
      });
    }

    function selectedAccessoryOption(card) {
      var select = card.querySelector('[data-er-accessory-variant]');
      return select && select.options.length ? select.options[select.selectedIndex] : null;
    }

    function normalizeModelKey(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, '-');
    }

    function setProgress(hasModel) {
      progressSteps.forEach(function (step) {
        var number = Number(step.dataset.erProgressStep);
        step.classList.toggle('is-active', number === (hasModel ? 2 : 1));
        step.classList.toggle('is-ready', hasModel && number <= 3);
      });
    }

    function updateAccessoryCard(card) {
      var checkbox = card.querySelector('[data-er-accessory-checkbox]');
      var option = selectedAccessoryOption(card);
      var price = card.querySelector('[data-er-accessory-price]');
      var image = card.querySelector('[data-er-accessory-image]');
      var state = card.querySelector('[data-er-accessory-state]');
      var available = option && option.dataset.available === 'true';

      if (price && option) price.textContent = option.dataset.priceFormatted || formatMoney(option.dataset.price);
      if (image && option && option.dataset.image) image.src = option.dataset.image;
      if (checkbox) {
        checkbox.disabled = !available;
        if (!available) checkbox.checked = false;
      }
      card.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked));
      if (state) {
        state.textContent = available
          ? (checkbox && checkbox.checked ? 'Selected' : (root.dataset.optionalText || 'Optional'))
          : (root.dataset.soldOutText || 'Sold out');
      }
    }

    function filterAccessories(modelKey) {
      var visibleCount = 0;
      var normalizedModelKey = normalizeModelKey(modelKey);
      accessoryCards.forEach(function (card) {
        var compatible = (card.dataset.compatibleModels || '')
          .split(',')
          .map(normalizeModelKey)
          .filter(Boolean);
        var show = Boolean(
          normalizedModelKey &&
          (card.dataset.allModels === 'true' || compatible.indexOf(normalizedModelKey) !== -1)
        );
        var checkbox = card.querySelector('[data-er-accessory-checkbox]');
        card.hidden = !show;
        if (!show && checkbox) checkbox.checked = false;
        if (show) {
          visibleCount += 1;
          updateAccessoryCard(card);
        }
      });

      if (accessoryPrompt) accessoryPrompt.hidden = Boolean(modelKey);
      if (accessoryEmpty) accessoryEmpty.hidden = !modelKey || visibleCount > 0;
    }

    function appendSummaryRow(title, subtitle, price) {
      var item = document.createElement('li');
      var name = document.createElement('strong');
      var amount = document.createElement('span');
      var detail = document.createElement('small');
      name.textContent = title;
      amount.textContent = formatMoney(price);
      detail.textContent = subtitle;
      item.appendChild(name);
      item.appendChild(amount);
      item.appendChild(detail);
      summaryList.appendChild(item);
    }

    function selectedItems() {
      var model = currentModelOption();
      if (!model || model.dataset.available !== 'true') return [];

      var items = [{ id: Number(model.dataset.variantId), quantity: 1 }];
      accessoryCards.forEach(function (card) {
        if (card.hidden) return;
        var checkbox = card.querySelector('[data-er-accessory-checkbox]');
        var option = selectedAccessoryOption(card);
        if (checkbox && checkbox.checked && option && option.dataset.available === 'true') {
          items.push({ id: Number(option.value), quantity: 1 });
        }
      });

      return items.reduce(function (result, item) {
        var existing = result.find(function (candidate) { return candidate.id === item.id; });
        if (existing) existing.quantity += item.quantity;
        else result.push(item);
        return result;
      }, []);
    }

    function updateSummary() {
      var model = currentModelOption();
      var subtotal = 0;
      summaryList.textContent = '';

      if (!model) {
        if (summaryEmpty) summaryEmpty.hidden = false;
        total.textContent = '—';
        addToCart.disabled = true;
        checkout.disabled = true;
        return;
      }

      if (summaryEmpty) summaryEmpty.hidden = true;
      subtotal += Number(model.dataset.price) || 0;
      appendSummaryRow(
        model.dataset.productTitle,
        model.dataset.variantTitle,
        Number(model.dataset.price)
      );

      accessoryCards.forEach(function (card) {
        if (card.hidden) return;
        var checkbox = card.querySelector('[data-er-accessory-checkbox]');
        var option = selectedAccessoryOption(card);
        if (!checkbox || !checkbox.checked || !option) return;
        var title = card.querySelector('h4');
        var accessoryPrice = Number(option.dataset.price) || 0;
        subtotal += accessoryPrice;
        appendSummaryRow(
          title ? title.textContent.trim() : 'Accessory',
          option.textContent.trim(),
          accessoryPrice
        );
      });

      total.textContent = formatMoney(subtotal);
      addToCart.disabled = model.dataset.available !== 'true';
      checkout.disabled = model.dataset.available !== 'true';
    }

    function closeSceneDialog() {
      if (!sceneDialog) return;
      if (typeof sceneDialog.close === 'function' && sceneDialog.open) sceneDialog.close();
      else sceneDialog.removeAttribute('open');
      document.body.classList.remove('er-setup-builder-scene-open');
      if (sceneReturnFocus && typeof sceneReturnFocus.focus === 'function') sceneReturnFocus.focus();
      sceneReturnFocus = null;
    }

    function openSceneDialog(button) {
      if (!sceneDialog || !button) return;
      var cardImage = button.querySelector('[data-er-accessory-image]');
      var source = button.dataset.sceneImage || (cardImage ? cardImage.currentSrc || cardImage.src : '');
      if (!source) return;

      sceneReturnFocus = button;
      if (sceneImage) {
        sceneImage.src = source;
        sceneImage.alt = button.dataset.sceneAlt || button.dataset.sceneTitle || '';
      }
      if (sceneTitle) sceneTitle.textContent = button.dataset.sceneTitle || '';
      if (sceneCaption) {
        sceneCaption.textContent = button.dataset.sceneCaption || '';
        sceneCaption.hidden = !button.dataset.sceneCaption;
      }

      document.body.classList.add('er-setup-builder-scene-open');
      if (typeof sceneDialog.showModal === 'function') {
        if (!sceneDialog.open) sceneDialog.showModal();
      } else {
        sceneDialog.setAttribute('open', '');
      }
    }

    function updateModel() {
      var model = currentModelOption();
      var hasModel = Boolean(model);
      var modelKey = hasModel ? model.dataset.modelKey : '';

      if (modelPlaceholder) modelPlaceholder.hidden = hasModel;
      if (modelCard) modelCard.hidden = !hasModel;

      if (hasModel) {
        if (modelImage) {
          modelImage.src = model.dataset.image || '';
          modelImage.alt = model.dataset.imageAlt || model.dataset.productTitle || '';
          modelImage.hidden = !model.dataset.image;
        }
        if (modelTitle) modelTitle.textContent = model.dataset.productTitle || '';
        if (modelVariant) modelVariant.textContent = model.dataset.variantTitle || '';
        if (modelPrice) modelPrice.textContent = model.dataset.priceFormatted || formatMoney(model.dataset.price);
        if (modelDescription) modelDescription.textContent = model.dataset.description || '';
        if (modelStock) {
          var available = model.dataset.available === 'true';
          modelStock.textContent = available ? 'In stock' : 'Sold out';
          modelStock.classList.toggle('is-sold-out', !available);
        }
      }

      filterAccessories(modelKey);
      setProgress(hasModel);
      updateSummary();
      if (status) status.textContent = '';
    }

    accessoryCards.forEach(function (card) {
      var checkbox = card.querySelector('[data-er-accessory-checkbox]');
      var select = card.querySelector('[data-er-accessory-variant]');
      var sceneButton = card.querySelector('[data-er-scene-open]');
      if (checkbox) {
        checkbox.addEventListener('change', function () {
          updateAccessoryCard(card);
          updateSummary();
        });
      }
      if (select) {
        select.addEventListener('change', function () {
          updateAccessoryCard(card);
          updateSummary();
        });
      }
      if (sceneButton) {
        sceneButton.addEventListener('click', function () {
          openSceneDialog(sceneButton);
        });
      }
      updateAccessoryCard(card);
    });

    modelChoices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        selectModel(choice);
        updateModel();
      });
      choice.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(event.key) === -1) return;
        event.preventDefault();
        var currentIndex = modelChoices.indexOf(choice);
        var direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
        var nextChoice = modelChoices[(currentIndex + direction + modelChoices.length) % modelChoices.length];
        selectModel(nextChoice);
        updateModel();
        nextChoice.focus();
      });
    });

    if (sceneClose) sceneClose.addEventListener('click', closeSceneDialog);
    if (sceneDialog) {
      sceneDialog.addEventListener('click', function (event) {
        if (event.target === sceneDialog) closeSceneDialog();
      });
      sceneDialog.addEventListener('close', function () {
        document.body.classList.remove('er-setup-builder-scene-open');
      });
    }

    function addSetupToCart() {
      var items = selectedItems();
      if (!items.length || isSubmitting) return;

      isSubmitting = true;
      addToCart.disabled = true;
      checkout.disabled = true;
      addToCart.setAttribute('aria-busy', 'true');
      if (status) status.textContent = root.dataset.loadingText || 'Adding your setup…';

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 15000);

      fetch(root.dataset.cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items }),
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () { return {}; }).then(function (body) {
              throw new Error(body.description || body.message || 'Cart update failed');
            });
          }
          return response.json();
        })
        .then(function () {
          window.clearTimeout(timeout);
          if (status) status.textContent = 'Added. Opening your cart…';
          window.location.assign(root.dataset.cartUrl || '/cart');

          window.setTimeout(function () {
            if (document.visibilityState === 'visible') {
              isSubmitting = false;
              addToCart.removeAttribute('aria-busy');
              updateSummary();
            }
          }, 4000);
        })
        .catch(function (error) {
          window.clearTimeout(timeout);
          isSubmitting = false;
          addToCart.removeAttribute('aria-busy');
          updateSummary();
          if (status) {
            status.textContent = (root.dataset.errorText || 'We could not add this setup.') +
              (error && error.name === 'AbortError'
                ? ' The request timed out. Please try again.'
                : (error && error.message ? ' ' + error.message : ''));
          }
        });
    }

    function directCheckout() {
      var items = selectedItems();
      if (!items.length || isSubmitting) return;

      isSubmitting = true;
      addToCart.disabled = true;
      checkout.disabled = true;
      checkout.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Opening secure Shopify Checkout…';

      var cartBase = (root.dataset.cartUrl || '/cart').replace(/\/$/, '');
      var cartLines = items.map(function (item) {
        return encodeURIComponent(item.id) + ':' + encodeURIComponent(item.quantity);
      }).join(',');
      window.location.assign(cartBase + '/' + cartLines + '?checkout');

      window.setTimeout(function () {
        if (document.visibilityState === 'visible') {
          isSubmitting = false;
          checkout.removeAttribute('aria-busy');
          updateSummary();
        }
      }, 4000);
    }

    addToCart.addEventListener('click', function () {
      addSetupToCart();
    });

    checkout.addEventListener('click', function () {
      directCheckout();
    });

    selectModel(
      modelChoices.find(function (choice) {
        return choice.dataset.available === 'true';
      }) || modelChoices[0]
    );
    updateModel();
  }

  function init(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-er-setup-builder]')) createController(target);
    Array.prototype.forEach.call(target.querySelectorAll('[data-er-setup-builder]'), createController);
  }

  window.EagleroamSetupBuilder = window.EagleroamSetupBuilder || { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
